/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_Empty_Folder_DescriptionInputs */

const en_files_empty_folder_description = /** @type {(inputs: Files_Empty_Folder_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This folder is empty. Add files by moving them from other folders or uploading new content.`)
};

const es_files_empty_folder_description = /** @type {(inputs: Files_Empty_Folder_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta carpeta está vacía. Agrega archivos moviéndolos de otras carpetas o subiendo contenido nuevo.`)
};

/**
* | output |
* | --- |
* | "This folder is empty. Add files by moving them from other folders or uploading new content." |
*
* @param {Files_Empty_Folder_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_empty_folder_description = /** @type {((inputs?: Files_Empty_Folder_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Empty_Folder_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_empty_folder_description(inputs)
	return en_files_empty_folder_description(inputs)
});